/**
 * Court spot codes (R20), shared by drills, the shot diagram and Game Lab.
 * Threes: lc lw top rw rc. Midrange: lb le ft re rb. Layups: l r.
 * `ft` is the free-throw line spot of the Midrange Tour. Charity Stripe attempts also use
 * spot `ft` but carry shotClass 'ft' on the attempt, so the class decides, not the spot.
 */

export const SPOT_KEYS = ['lc', 'lw', 'top', 'rw', 'rc', 'lb', 'le', 'ft', 're', 'rb', 'l', 'r'] as const;
export type SpotKey = (typeof SPOT_KEYS)[number];

export const THREE_SPOTS = ['lc', 'lw', 'top', 'rw', 'rc'] as const satisfies readonly SpotKey[];
export const MID_SPOTS = ['lb', 'le', 'ft', 're', 'rb'] as const satisfies readonly SpotKey[];
export const LAYUP_SPOTS = ['l', 'r'] as const satisfies readonly SpotKey[];

/** Default shot class of a spot when no explicit class is given. */
export const SPOT_SHOT_CLASS: Record<SpotKey, 'three' | 'mid' | 'rim'> = {
  lc: 'three',
  lw: 'three',
  top: 'three',
  rw: 'three',
  rc: 'three',
  lb: 'mid',
  le: 'mid',
  ft: 'mid',
  re: 'mid',
  rb: 'mid',
  l: 'rim',
  r: 'rim',
};

export const SPOT_LABEL: Record<SpotKey, string> = {
  lc: 'Left corner',
  lw: 'Left wing',
  top: 'Top of the key',
  rw: 'Right wing',
  rc: 'Right corner',
  lb: 'Left baseline',
  le: 'Left elbow',
  ft: 'Free throw line',
  re: 'Right elbow',
  rb: 'Right baseline',
  l: 'Left side layup',
  r: 'Right side layup',
};
